import Marquee from 'react-fast-marquee';

const phrases = [
  "OZFEST",
  "THE SPIRIT OF AUSTRALIA IN LAS VEGAS",
  "SPORT \u2022 CULTURE \u2022 ENERGY",
  "AN UNFORGETTABLE EXPERIENCE",
];

export default function MarqueeBanner() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-black border-t border-gold/20"
      data-testid="marquee-banner"
    >
      <Marquee speed={50} gradient={false} className="py-2.5">
        {[...phrases, ...phrases].map((phrase, i) => (
          <span key={i} className="inline-flex items-center mx-6 md:mx-12">
            <span className="font-heading text-[10px] md:text-xs tracking-[0.3em] uppercase text-white/80">
              {phrase}
            </span>
            <span className="text-gold/50 mx-6 md:mx-10 text-[8px]">{'\u2726'}</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
